"use strict";

require("core-js/modules/es6.regexp.replace");

exports.__esModule = true;

var utils_1 = require("./utils");

var setting_1 = require("./setting");

function consoleTransportBrowser(level, message, formatMessage, time, timeEndLimit) {
  var text = formatMessage;
  var colorMessage;

  if (time && timeEndLimit && time > timeEndLimit) {
    text = text.replace(/\s\d+ms/, ' %c' + time + 'ms');
    var color = setting_1.LOG_LEVEL[level].color;
    colorMessage = ['%c' + text, 'color:' + color, 'color:red'];
  } else {
    colorMessage = utils_1.getColorMessage(level, text);
  }

  console[console[level] ? level : 'log'].apply(console, colorMessage);
  return colorMessage;
}

exports.consoleTransportBrowser = consoleTransportBrowser;

function consoleTransportNode(level, message, formatMessage, time, timeEndLimit) {
  var text = formatMessage;

  if (time && timeEndLimit && time > timeEndLimit) {
    text = text.replace(/\s\d+ms/, ' \x1b[31m' + time + 'ms' + '\x1b[0m');
  }

  var colorMessage = utils_1.getColorMessage(level, text);
  console[console[level] ? level : 'log'].apply(console, colorMessage);
  return colorMessage;
}

exports.consoleTransportNode = consoleTransportNode;
exports["default"] = utils_1.isNode() ? consoleTransportNode : consoleTransportBrowser;